import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../../constant/Constant';
import { request } from '../ApiModule';

const BASE = 'modal/PDF_VIEW';
const ACTION_SEARCH = BASE + PATH_DELIMITER + 'ACTION_SEARCH';
const HANDLE_DATA = BASE + PATH_DELIMITER + 'HANDLE_DATA';

export const actionSearch = createAction(ACTION_SEARCH);

export function* pdfViewSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
}

function* actionSearchSaga({ payload: { params, callback, downloadProgress } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/file/export',
        params,
        download: true,
        downloadProgress,
    });

    callback && callback(result);
}

const initialState = {
};

const module = handleActions(
    {
        [HANDLE_DATA]: (state, { payload }) => ({ ...state, ...payload }),
    },
    initialState,
);

export default module;
